import { render, staticRenderFns } from "./registerGoods.vue?vue&type=template&id=1327e92e&scoped=true"
import script from "./registerGoods.vue?vue&type=script&lang=js"
export * from "./registerGoods.vue?vue&type=script&lang=js"
import style0 from "./registerGoods.vue?vue&type=style&index=0&id=1327e92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327e92e",
  null
  
)

export default component.exports